export default "__VITE_ASSET__BXFP$0Hz__"